import {
  Avatar,
  InputAdornment,
  TextField,
  Tooltip,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { s3baseUrl } from "src/config/config";
import { Icon } from "@iconify/react";
import {
  getPaceText,
  getMihrForPace,
  getKmhrForPace,
  getPaceTextinPaces,
  formatWithLeadingZeros,
} from "src/utils/constant";

const CustomComplateFeild = ({
  exerData,
  message,
  handleArrowSuperSet,
  handleClickOpen,
  isSidebar,
  isWithHistoryAndBigScreen,
  memberId,
  index,
  exerIndex,
}) => {
  return (
    <div className="ms-4 my-1">
      <div
        className="d-flex workout-set-card  "
        style={{
          width: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
          }}
        >
          <div className="row  ">
            <div
              className={`col-sm-12 ${"col-md-6"} col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0 `}
            >
              <div className="exercise-label-box">
                <span className="outer-label">Exercise</span>
                <div className="d-flex align-items-center justify-content-between">
                  <Tooltip placement="top" touch="on" title={message}>
                    <div className="w-100">
                      <div className="exercise-label w-100">
                        <div className="d-flex align-items-center">
                          {exerData?.exercise?.image?.thumbnail_3 && (
                            <Avatar
                              sx={{
                                borderRadius: "5px",
                              }}
                              alt="User Image"
                              src={
                                s3baseUrl +
                                exerData?.exercise?.image?.thumbnail_3
                              }
                            />
                          )}
                          <div className="label-text ms-1">
                            {exerData?.exercise?.title
                              ? exerData?.exercise?.title
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                  <div className="exercise-action">
                    <div style={{ fontSize: "16px" }}>
                      {exerData?.exercise ? (
                        <div>
                          <InfoIcon
                            onClick={() =>
                              handleClickOpen(exerData?.exercise?._id)
                            }
                            className="d-block"
                            fontSize="14px"
                            sx={{
                              opacity: 0.5,
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      ) : (
                        <AddIcon
                          sx={{
                            opacity: 0.5,
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <Button
                sx={{ textTransform: "inherit" }}
                size="small"
                color="primary"
                variant="contained"
                className="d-flex align-items-center ms-2 small-contained-dialog-button"
                onClick={() => {
                  handleArrowSuperSet(
                    !exerData?.open ? true : false,
                    index,
                    exerIndex
                  );
                }}
              >
                {!exerData?.open ? (
                  <KeyboardArrowDownIcon
                    sx={{
                      cursor: "pointer",
                      fontSize: "20px",
                    }}
                  />
                ) : (
                  <KeyboardArrowUpIcon
                    sx={{
                      cursor: "pointer",
                      fontSize: "20px",
                    }}
                  />
                )}

                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {` Sets ${1}`}
                </Typography>
              </Button>
            </div>

            <div
              className={`col-sm-12 ${"col-md-5"} col-lg-6 p-0 mt-2 mt-md-0 mt-lg-0  d-flex align-items-center justify-content-start `}
            >
              <div className="d-flex align-items-center mx-1">
                <Tooltip touch="on" placement="top" title={message}>
                  <div className="d-flex align-items-center ms-3 set-parameters ">
                    <Icon icon="pajamas:labels" fontSize="10px" />
                    <Typography variant="body2" sx={{ ml: 0.5 }}>
                      {`Parameters`}
                    </Typography>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
          {exerData?.open &&
            exerData?.set?.map((item, setIndex) => (
              <div className="d-flex align-items-center my-3 w-100 workout-card-inset">
                <Tooltip placement="top" title={message}>
                  <div className="row w-100">
                    {exerData.parameters.includes("Vdot") && (
                      <>
                        {memberId && (
                          <div
                            className={
                              isWithHistoryAndBigScreen
                                ? "col-2 pe-0 py-1"
                                : `col-12 col-md-2 col-lg-1 pe-0 py-1`
                            }
                          >
                            <TextField
                              id="outlined-basic"
                              readOnly
                              size="small"
                              variant="outlined"
                              placeholder="0"
                              type="number"
                              label="Auto Pacer"
                              value={item?.vdot}
                              name="vdot"
                              InputLabelProps={{
                                className: "textfiels-input-label",
                                shrink: true,
                                style: {
                                  fontSize: "14px",
                                },
                              }}
                              InputProps={{
                                className: "textfiels-input-value",
                                style: {
                                  fontSize: "13px",
                                  paddingLeft: "0px",
                                  paddingRight: "5px",
                                },
                                readOnly: true,
                              }}
                              sx={{
                                borderRadius: "5px",
                                fontSize: "13px",
                                width: "100%",
                                marginTop: "5px",
                              }}
                            />
                          </div>
                        )}
                        <div
                          className={
                            isWithHistoryAndBigScreen
                              ? "col-5 pe-0 py-1"
                              : `col-12 col-md-5 ${
                                  isSidebar ? "col-lg-4" : "col-lg-3"
                                } pe-0 py-1`
                          }
                        >
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            label="Type"
                            readOnly
                            InputLabelProps={{
                              readOnly: true,
                              className: "textfiels-input-label",
                              shrink: true,
                              style: {
                                fontSize: "14px",
                              },
                            }}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "13px",
                                paddingLeft: "0px",
                                paddingRight: "0px",

                                justifyContent: "center",
                              },
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Select
                                    id="select-option"
                                    readOnly
                                    variant="outlined"
                                    size="small"
                                    name="race_type"
                                    value={item?.race_type}
                                    label="Weight Type"
                                    inputProps={{
                                      readOnly: true,
                                      style: {
                                        padding: 0,
                                      },
                                    }}
                                    sx={{
                                      "& legend": {
                                        display: "none",
                                      },
                                      "& fieldset": {
                                        top: 0,
                                      },
                                      fontSize: "13px",
                                      border: "none",
                                      "& fieldset": {
                                        border: "none",
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        padding: 0,
                                      },
                                    }}
                                  >
                                    <MenuItem value="el">Easy/Long</MenuItem>
                                    <MenuItem value="c">Compromised</MenuItem>
                                    <MenuItem value="t">Threshold</MenuItem>
                                    <MenuItem value="i">Interval</MenuItem>
                                    <MenuItem value="r">Repitition</MenuItem>
                                  </Select>

                                  <Select
                                    id="select-option"
                                    variant="outlined"
                                    readOnly
                                    size="small"
                                    name="pace_type"
                                    value={item?.pace_type}
                                    label="Weight Type"
                                    inputProps={{
                                      readOnly: true,
                                      style: {
                                        padding: 0,
                                      },
                                    }}
                                    sx={{
                                      "& legend": {
                                        display: "none",
                                      },
                                      "& fieldset": {
                                        top: 0,
                                      },
                                      fontSize: "13px",
                                      border: "none",
                                      "& fieldset": {
                                        border: "none",
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        padding: 0,
                                      },
                                    }}
                                  >
                                    {item?.optionsType?.map((option) => {
                                      return (
                                        <MenuItem
                                          key={option?.key}
                                          value={option?.key}
                                        >
                                          {option?.title}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              borderRadius: "5px",
                              fontSize: "13px",

                              marginTop: "5px",
                              "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                {
                                  width: "0px !important",
                                  padding: "9px 0px !important",
                                },
                              "& .css-1nuss9t": {
                                width: "0px !important",
                                padding: "9px 0px !important",
                              },

                              width: "100%",
                            }}
                          />
                        </div>
                        {exerData.parameters.includes("Distance") && (
                          <div
                            className={
                              isWithHistoryAndBigScreen
                                ? "col-3 pe-0 py-2"
                                : `col-12 col-md-3 col-lg-2 pe-0 py-2`
                            }
                          >
                            <TextField
                              sx={{
                                borderRadius: "5px",
                                paddingRight: 0,
                                width: "100%",
                              }}
                              readOnly
                              size="small"
                              id="custom-input"
                              variant="outlined"
                              placeholder={"Distance"}
                              name="distance"
                              label="Distance"
                              value={item?.distance}
                              type="number"
                              InputLabelProps={{
                                className: "textfiels-input-label",
                                shrink: true,
                                style: {
                                  fontSize: "14px",
                                },
                              }}
                              InputProps={{
                                readOnly: true,
                                className: "textfiels-input-value",
                                style: {
                                  fontSize: "13px",
                                  paddingRight: 0,
                                },
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Select
                                      id="select-option"
                                      variant="outlined"
                                      readOnly
                                      size="small"
                                      name="distanceType"
                                      value={item?.distanceType}
                                      label="Weight Type"
                                      sx={{
                                        "& legend": {
                                          display: "none",
                                        },
                                        "& fieldset": {
                                          top: 0,
                                        },
                                        fontSize: "13px",
                                        border: "none",
                                        "& fieldset": {
                                          border: "none",
                                        },
                                      }}
                                    >
                                      <MenuItem value="m">Meter</MenuItem>
                                      <MenuItem value="km">KM</MenuItem>
                                      <MenuItem value="mi">Mile</MenuItem>
                                    </Select>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        )}
                        {memberId ? (
                          item?.race_type == "el" ? (
                            <div
                              className={
                                isWithHistoryAndBigScreen
                                  ? "col-3 pe-0 py-1"
                                  : `col-12 col-md-3 col-lg-2 pe-0 py-1`
                              }
                            >
                              <TextField
                                readOnly
                                id="outlined-basic"
                                variant="outlined"
                                label={getPaceText(item?.pace_type)}
                                InputLabelProps={{
                                  className: "textfiels-input-label",
                                  shrink: true,
                                  style: {
                                    fontSize: "14px",
                                  },
                                }}
                                InputProps={{
                                  className: "textfiels-input-value",
                                  style: {
                                    fontSize: "13px",
                                    paddingLeft: "0px",
                                    paddingRight: "0px",

                                    justifyContent: "center",
                                  },
                                  readOnly: true,
                                  endAdornment: (
                                    <InputAdornment
                                      position="end"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <TextField
                                        id="outlined-basic-minutes"
                                        readOnly
                                        type="number"
                                        size="small"
                                        placeholder="Min"
                                        name="pace"
                                        value={formatWithLeadingZeros(
                                          Math.floor(item?.pace / 60)
                                        )}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                      <div className="fs-6 fw-semibold ms-1 ">
                                        :
                                      </div>
                                      <TextField
                                        id="outlined-basic-seconds"
                                        type="number"
                                        readOnly
                                        size="small"
                                        placeholder="Sec"
                                        name="pace"
                                        value={formatWithLeadingZeros(
                                          item?.pace % 60
                                        )}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                            // width: "40px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                      <div className="fs-6 fw-semibold ms-1 me-1 ">
                                        -
                                      </div>
                                      <TextField
                                        id="outlined-basic-minutes"
                                        readOnly
                                        type="number"
                                        size="small"
                                        placeholder="Min"
                                        name="paceUp"
                                        value={formatWithLeadingZeros(
                                          Math.floor(item?.paceUp / 60)
                                        )}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                            // width: "40px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                      <div className="fs-6 fw-semibold ms-1">
                                        :
                                      </div>
                                      <TextField
                                        id="outlined-basic-seconds"
                                        type="number"
                                        size="small"
                                        placeholder="Sec"
                                        readOnly
                                        name="paceUp"
                                        value={formatWithLeadingZeros(
                                          item?.paceUp % 60
                                        )}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                            // width: "40px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                          marginRight: 1,
                                        }}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  borderRadius: "5px",
                                  fontSize: "13px",

                                  marginTop: "5px",
                                  "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      width: "0px !important",
                                      padding: "9px 0px !important",
                                    },
                                  "& .css-1nuss9t": {
                                    width: "0px !important",
                                    padding: "9px 0px !important",
                                  },

                                  width: "100%",
                                }}
                              />
                            </div>
                          ) : (
                            <div
                              className={
                                isWithHistoryAndBigScreen
                                  ? "col-2 pe-0 py-1"
                                  : `col-12 col-md-2 col-lg-1 pe-0 py-1`
                              }
                            >
                              <TextField
                                id="outlined-basic"
                                variant="outlined"
                                label={getPaceText(item?.pace_type)}
                                readOnly
                                InputLabelProps={{
                                  className: "textfiels-input-label",
                                  shrink: true,
                                  style: {
                                    fontSize: "14px",
                                  },
                                }}
                                InputProps={{
                                  className: "textfiels-input-value",
                                  style: {
                                    fontSize: "13px",
                                    paddingLeft: "0px",
                                    paddingRight: "0px",

                                    justifyContent: "center",
                                  },
                                  readOnly: true,
                                  endAdornment: (
                                    <InputAdornment
                                      position="end"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <TextField
                                        id="outlined-basic-minutes"
                                        type="number"
                                        readOnly
                                        size="small"
                                        placeholder="Min"
                                        name="pace"
                                        value={formatWithLeadingZeros(
                                          Math.floor(item?.pace / 60)
                                        )}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                      <div className="fs-6 fw-semibold ms-1 ">
                                        :
                                      </div>
                                      <TextField
                                        id="outlined-basic-seconds"
                                        type="number"
                                        readOnly
                                        size="small"
                                        placeholder="Sec"
                                        name="pace"
                                        value={formatWithLeadingZeros(
                                          item?.pace % 60
                                        )}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                            // width: "40px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      width: "0px !important",
                                      padding: "9px 0px !important",
                                    },
                                  "& .css-1nuss9t": {
                                    width: "0px !important",
                                    padding: "9px 0px !important",
                                  },
                                  width: "100%",
                                  marginTop: "5px",
                                }}
                              />
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {exerData.parameters.includes("Pace") && (
                      <>
                        <div className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}>
                          <FormControl readOnly fullWidth>
                            <InputLabel
                              className="set-Type-lable"
                              sx={{
                                fontSize: "14px",
                              }}
                              id="demo-simple-select-label"
                            >
                              Type
                            </InputLabel>

                            <Select
                              className="set-Type-value"
                              id="select-option"
                              variant="outlined"
                              size="small"
                              name="race_type"
                              value={item?.race_type}
                              label="Type"
                              readOnly="true"
                              inputProps={{
                                style: {
                                  padding: 0,
                                },
                              }}
                              sx={{
                                width: "100%",
                                fontSize: "13px",
                                "& .MuiOutlinedInput-input": {
                                  paddingLeft: 1,
                                },
                              }}
                            >
                              <MenuItem value="el">Easy/Long</MenuItem>
                              <MenuItem value="c">Compromised</MenuItem>
                              <MenuItem value="i">Interval</MenuItem>
                              <MenuItem value="r">Repitition</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}>
                          <TextField
                            sx={{
                              borderRadius: "5px",
                              paddingRight: 0,
                              width: "100%",
                            }}
                            readOnly
                            size="small"
                            id="custom-input"
                            variant="outlined"
                            placeholder={"Distance"}
                            name="distance"
                            label="Distance"
                            value={item?.distance}
                            type="number"
                            InputLabelProps={{
                              className: "textfiels-input-label",
                              shrink: true,
                              style: {
                                fontSize: "14px",
                              },
                            }}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "13px",
                                paddingRight: 0,
                              },
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Select
                                    id="select-option"
                                    variant="outlined"
                                    size="small"
                                    name="distanceType"
                                    value={item?.distanceType}
                                    label="Weight Type"
                                    readOnly={true}
                                    sx={{
                                      "& legend": {
                                        display: "none",
                                      },
                                      "& fieldset": {
                                        top: 0,
                                      },
                                      fontSize: "13px",
                                      border: "none",
                                      "& fieldset": {
                                        border: "none",
                                      },
                                    }}
                                  >
                                    <MenuItem value="m">Meter</MenuItem>
                                    <MenuItem value="km">KM</MenuItem>
                                    <MenuItem value="mi">Mile</MenuItem>
                                  </Select>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        <div className={`col-12 col-md-2 col-lg-2 pe-0 py-2`}>
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            label={getPaceTextinPaces(item?.distanceType)}
                            InputLabelProps={{
                              className: "textfiels-input-label",
                              shrink: true,
                              style: {
                                fontSize: "14px",
                              },
                            }}
                            readOnly={true}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "13px",
                                paddingLeft: "0px",
                                paddingRight: "0px",

                                justifyContent: "center",
                              },
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <TextField
                                    id="outlined-basic-minutes"
                                    type="number"
                                    size="small"
                                    placeholder="Min"
                                    name="pace"
                                    value={formatWithLeadingZeros(
                                      Math.floor(item?.pace / 60)
                                    )}
                                    readOnly={true}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "14px",
                                      },
                                      readOnly: true,
                                    }}
                                    sx={{
                                      "& fieldset": {
                                        border: "none",
                                      },
                                      "& input": {
                                        textAlign: "center",
                                        padding: "0px",
                                      },
                                      width: "100%",
                                    }}
                                  />
                                  <div className="fs-6 fw-semibold ms-1 ">
                                    :
                                  </div>

                                  <TextField
                                    id="outlined-basic-seconds"
                                    type="number"
                                    size="small"
                                    placeholder="Sec"
                                    name="pace"
                                    value={formatWithLeadingZeros(
                                      item?.pace % 60
                                    )}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "14px",
                                      },
                                      readOnly: true,
                                    }}
                                    sx={{
                                      "& fieldset": {
                                        border: "none",
                                      },
                                      "& input": {
                                        textAlign: "center",
                                        padding: "0px",
                                      },
                                      width: "100%",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              borderRadius: "5px",
                              fontSize: "13px",
                              "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                {
                                  width: "0px !important",
                                  padding: "9px 0px !important",
                                },
                              "& .css-1nuss9t": {
                                width: "0px !important",
                                padding: "9px 0px !important",
                              },
                              width: "100%",
                            }}
                          />
                        </div>
                      </>
                    )}
                    {exerData.parameters.includes("Pace") ||
                      (exerData.parameters.includes("Vdot") && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: "4px",
                            left: "5px",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{
                              opacity: 0.6,
                              fontWeight: "600",
                              fontSize: "12px",
                            }}
                          >{` @ Speed ${getKmhrForPace(
                            item?.distance,
                            item?.pace,
                            item?.distanceType
                          )} km/hr or ${getMihrForPace(
                            item?.distance,
                            item?.pace,
                            item?.distanceType
                          )} mi/hr`}</Typography>
                        </div>
                      ))}
                    {(exerData.parameters.includes("Duration/Pace") ||
                      exerData.parameters.includes("Time")) && (
                      <div className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          readOnly={true}
                          placeholder="0"
                          type="number"
                          value={item?.time}
                          name="time"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          label={
                            exerData.parameters.includes("Duration/Pace")
                              ? "Duration/Pace"
                              : "Time"
                          }
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  name="timeType"
                                  value={item?.timeType}
                                  label="Weight Type"
                                  inputProps={{
                                    style: {
                                      padding: 0,
                                    },
                                  }}
                                  readOnly={true}
                                  sx={{
                                    "& legend": {
                                      display: "none",
                                    },
                                    "& fieldset": {
                                      top: 0,
                                    },
                                    fontSize: "13px",
                                    border: "none",
                                    "& fieldset": {
                                      border: "none",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: 0,
                                    },
                                  }}
                                >
                                  <MenuItem value="sec">sec</MenuItem>
                                  <MenuItem value="min">min</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                    )}

                    {exerData.parameters.includes("Reps") && (
                      <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Reps"
                          type="text"
                          label="Reps"
                          value={item?.reps}
                          name="reps"
                          readOnly
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                            readOnly: true,
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Max_Reps") && (
                      <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Max Reps"
                          type="text"
                          label="Max Reps"
                          value={item?.maxReps}
                          name="maxReps"
                          readOnly
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                            readOnly: true,
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Height") && (
                      <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="0"
                          type="number"
                          readOnly="true"
                          value={item?.height}
                          name="height"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          label="Height"
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  name="height_unit"
                                  value={item?.height_unit}
                                  label="Weight Type"
                                  inputProps={{
                                    style: {
                                      padding: 0,
                                    },
                                  }}
                                  readOnly
                                  sx={{
                                    "& legend": {
                                      display: "none",
                                    },
                                    "& fieldset": {
                                      top: 0,
                                    },
                                    fontSize: "13px",
                                    border: "none",
                                    "& fieldset": {
                                      border: "none",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: 0,
                                    },
                                  }}
                                >
                                  <MenuItem value="cm">Cm</MenuItem>
                                  <MenuItem value="ft">Feet</MenuItem>
                                  <MenuItem value="inch">Inch</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Weight") && (
                      <div className="col-12 col-md-4 col-lg-2 pe-0 py-2">
                        <TextField
                          sx={{
                            borderRadius: "5px",
                            paddingRight: 0,
                            width: "100%",
                          }}
                          size="small"
                          id="custom-input"
                          variant="outlined"
                          placeholder="Weight"
                          name="weight"
                          label="Weight"
                          readOnly="true"
                          value={item.weight}
                          type="number"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  readOnly
                                  name="weightType"
                                  value={item?.weightType}
                                  label="Weight Type"
                                  sx={{
                                    "& legend": {
                                      display: "none",
                                    },
                                    "& fieldset": {
                                      top: 0,
                                    },
                                    fontSize: "13px",
                                    border: "none",
                                    "& fieldset": {
                                      border: "none",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: 0,
                                    },
                                  }}
                                >
                                  <MenuItem value="1rm">% 1RM</MenuItem>
                                  <MenuItem value="body_weight">% BW</MenuItem>
                                  <MenuItem value="kg">KG</MenuItem>
                                  <MenuItem value="lb">Pound</MenuItem>
                                  <MenuItem value="poods">Poods</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Distance/Calories") && (
                      <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                        <TextField
                          sx={{
                            borderRadius: "5px",
                            paddingRight: 0,
                            width: "100%",
                          }}
                          size="small"
                          id="custom-input"
                          variant="outlined"
                          placeholder={
                            item?.distanceType == "calories"
                              ? "Calories"
                              : "Distance"
                          }
                          name="distance"
                          label="Distance/Calories"
                          value={item?.distance}
                          type="number"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  name="distanceType"
                                  value={item?.distanceType}
                                  label="Weight Type"
                                  readOnly={true}
                                  sx={{
                                    "& legend": {
                                      display: "none",
                                    },
                                    "& fieldset": {
                                      top: 0,
                                    },
                                    fontSize: "13px",
                                    border: "none",
                                    "& fieldset": {
                                      border: "none",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: 0,
                                    },
                                  }}
                                >
                                  <MenuItem value="m">Meter</MenuItem>
                                  <MenuItem value="km">KM</MenuItem>
                                  <MenuItem value="mi">Mile</MenuItem>
                                  <MenuItem value="calories">Calories</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("%MHR") && (
                      <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="%MHR"
                          type="number"
                          label="%MHR"
                          readOnly="true"
                          value={item?.mhr}
                          name="mhr"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                            readOnly: true,
                          }}
                          sx={{
                            borderRadius: "5px",

                            fontSize: "13px",
                            width: "100%",
                            "& .MuiOutlinedInput-input": {
                              padding: "8px 7px",
                            },
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("RPE") && (
                      <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="RPE"
                          label="RPE"
                          readOnly="true"
                          value={item?.RPE}
                          name="RPE"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                            readOnly: true,
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                            "& .MuiOutlinedInput-input": {
                              padding: "8px 7px",
                            },
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Tempo") && (
                      <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Tempo"
                          type="number"
                          label="Tempo"
                          readOnly="true"
                          value={item?.tempo}
                          name="tempo"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                            readOnly: true,
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                            "& .MuiOutlinedInput-input": {
                              padding: "8px 7px",
                            },
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Rest") && (
                      <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="0"
                          type="number"
                          readOnly
                          value={item?.rest}
                          name="rest"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          label="Rest"
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  readOnly
                                  size="small"
                                  name="restType"
                                  value={item?.restType}
                                  label="Weight Type"
                                  inputProps={{
                                    style: {
                                      padding: 0,
                                    },
                                  }}
                                  sx={{
                                    "& legend": {
                                      display: "none",
                                    },
                                    "& fieldset": {
                                      top: 0,
                                    },
                                    fontSize: "13px",
                                    border: "none",
                                    "& fieldset": {
                                      border: "none",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: 0,
                                    },
                                  }}
                                >
                                  <MenuItem value="sec">sec</MenuItem>
                                  <MenuItem value="min">min</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Tooltip>
              </div>
            ))}
        </Box>
      </div>
    </div>
  );
};

export default CustomComplateFeild;
